/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventEntryResponse = {
    properties: {
        id: {
            type: 'string',
            format: 'uuid4',
        },
        timestamp: {
            type: 'string',
            format: 'date-time',
        },
        userId: {
            type: 'number',
            isRequired: true,
        },
        action: {
            type: 'AuditLogActionEnum',
            isRequired: true,
        },
        payload: {
            type: 'any-of',
            contains: [{
                type: 'GoalEventCreateWithPlayer',
            }, {
                type: 'CardEventCreateWithPlayer',
            }, {
                type: 'ChangeEventCreateWithPlayer',
            }, {
                type: 'ChanceEventCreateWithPlayer',
            }, {
                type: 'GoalEventPatchWithPlayer',
            }, {
                type: 'CardEventPatchWithPlayer',
            }, {
                type: 'ChangeEventPatchWithPlayer',
            }, {
                type: 'ChanceEventPatchWithPlayer',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
